import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import Clients, { getClients } from "../helpers/Clients";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Invoices from "../helpers/Invoices";


export default function InvoiceCreate() {
    const { appState } = useAppState();
    const [clients, setClients] = useState<Array<any>>([])
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate()

    useEffect(() => {
        getClients().then((result) => {
            setClients(result)
        })
    }, [])


    const onSubmit = handleSubmit((values) => {
        if (values.clientId === "") {
            values.clientId = clients[0].id
        }

        if (values.clientId === "") {
            console.error('Client id is null');

            return;
        }

        Invoices.create({
            amount: values.amount * 100,
            clientId: values.clientId,
            currency: values.currency,
        }).then(() => {
            navigate('/invoices')
        })
    });

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Invoices \ New invoice</h1>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <form className="" onSubmit={onSubmit}>
                    <div className="space-y-4">
                        <select
                            required
                            {...register('clientId')}
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6">
                            {clients.map((client) => (<option value={client.id}>{client.name}</option>))}
                        </select>
                        <select
                            required
                            {...register('currency')}
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6">
                            <option value="usd">
                                USD
                            </option>
                            <option value="uah">
                                UAH
                            </option>
                        </select>
                        <input
                            {...register('amount')}
                            placeholder="Amount"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />

                        <div className="mt-6 flex items-center justify-end gap-x-6">
                            <Link to="/invoices" className="text-sm/6 font-semibold text-gray-900">
                                Cancel
                            </Link>
                            <button
                                type="submit"
                                className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
